import React from 'react';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMRoomResource from 'resources/SMRoomResource';
import SMUserResource from 'resources/SMUserResource';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMReservationRequestView from './SMReservationRequestView';
import SMStorage from 'lib/SMStorage';

class SMReservationBaseView extends React.Component {

  constructor(props) {
    super(props);
    const date = new Date();

    // default plan
    const plan = this.props.room.plans.length == 0 ? this.props.room : null;
    let isHourly = null;
    this.resetReservation();
    if (plan) {
      this.requestParams.plan_id = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
      isHourly = this.getIsHourly(plan);
      this.requestParams.is_hourly = isHourly;
    }

    this.planDidSelect = this.planDidSelect.bind(this);
    this.priceTypeDidSelect = this.priceTypeDidSelect.bind(this);
    this.checkinAtDidSelect = this.checkinAtDidSelect.bind(this);
    this.optionFoodDidSelect = this.optionFoodDidSelect.bind(this);
    this.optionItemDidSelect = this.optionItemDidSelect.bind(this);
    this.showRequestView = this.showRequestView.bind(this);

    this.state = {
      room: this.props.room,
      plan: plan,
      display: SMConst.Display.Visible,
      rentType: SMConst.RentType.DayTime,
      isHourly: isHourly,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
      validatedReservation: null,
      isValid: false,
      isRequestViewOpen: false,
      isContactViewOpen: false,
      numberOfGuests: 1,
      optionItems: {},
      optionFoods: {},
      errors: [],
      calendars: null,
      year: null,
      month: null,
      day: null,
    };

    // セッション情報の引き出し(予約リクエスト→ログイン→再度予約リクエスト画面の場合の考慮)
    this.setBeforeStateForLoginUser();
  }

  setBeforeStateForLoginUser() {
    const sessionReservationState = SMStorage.getSessionItem("SMReservationBaseViewState");
    const sessionRequestParams = SMStorage.getSessionItem("SMReservationBaseViewRequestParams");
    if (sessionReservationState != null && sessionRequestParams != null) {
      // セッション情報と同様のスペースの場合のみセッションより状態を復活させる
      if (sessionReservationState.room && this.props.room && sessionReservationState.room.id == this.props.room.id) {
        this.requestParams = sessionRequestParams;
        // 未ログイン -> ログインになるとdryrunの状態を変更する必要があるため、dryrunを別途更新
        this.requestParams.dryrun = this.props.currentUser ? false : true;
        // オプションの再設定
        if (sessionReservationState.room.option_items) {
          sessionReservationState.room.option_items.forEach((item) => {
            const searchTargetOptionItems = sessionRequestParams.reserved_option_items;
            if (searchTargetOptionItems) {
              const result = searchTargetOptionItems.find(target => target.option_item_id == item.id);
              if (result) {
                item.number = result.number;
                item.defaultChecked = true;
              }
            }
          });
        }

        // 飲食オプションの再設定
        if (sessionReservationState.room.option_foods) {
          sessionReservationState.room.option_foods.forEach((item) => {
            const searchTargetOptionFoods = sessionRequestParams.reserved_option_foods;
            if (searchTargetOptionFoods) {
              const result = searchTargetOptionFoods.find(target => target.option_food_id == item.id);
              if (result) {
                item.number = result.number;
                item.defaultChecked = true;
              }
            }
          });
        }

        this.state = {
          room: sessionReservationState.room,
          plan: sessionReservationState.plan,
          display: sessionReservationState.display,
          rentType: sessionReservationState.rentType,
          isHourly: sessionReservationState.isHourly,
          priceText: sessionReservationState.priceText,
          priceExtraText: sessionReservationState.priceExtraText,
          reservedDateText: sessionReservationState.reservedDateText,
          validatedReservation: sessionReservationState.validatedReservation,
          isValid: sessionReservationState.isValid,
          isRequestViewOpen: sessionReservationState.isRequestViewOpen,
          isContactViewOpen: sessionReservationState.isContactViewOpen,
          numberOfGuests: sessionReservationState.numberOfGuests,
          optionItems: sessionReservationState.optionItems,
          optionFoods: sessionReservationState.optionFoods,
          errors: sessionReservationState.errors,
          calendarState: sessionReservationState.calendarState,
          checkinEnable: sessionReservationState.checkinEnable,
        };
      }

      // 一度復活したらセッション情報は破棄する
      SMStorage.removeSessionItem("SMReservationBaseViewState");
      SMStorage.removeSessionItem("SMReservationBaseViewRequestParams");
    }
  }

  isStayPlan() {
    return this.state.plan.rent_type == SMConst.RentType.Stay;
  }

  isDayTimePlan() {
    return this.state.plan.rent_type == SMConst.RentType.DayTime;
  }

  isPerPersonPlan() {
    return this.state.plan.price_calc_type == SMConst.PriceCalcType.PerPerson;
  }

  getIsHourly(plan) {
    let isHourly = null;
    if (plan.has_session_price) {
      isHourly = plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour ? 1 : 0;
    }
    else if (!(plan.has_daily_price && plan.has_hourly_price)) {
      isHourly = plan.has_hourly_price ? 1 : 0;
    }
    else if (plan.has_stay_price) {
      isHourly = 0;
    }

    return isHourly;
  }

  resetReservation() {
    this.requestParams = {
      isValid: false,
      is_hourly: null,
      plan_id: null,
      reserved_schedules: [],
      reserved_option_items: [],
      reserved_option_foods: [],
      card_type: null,
      token: null,
      dryrun: this.props.currentUser ? false : true,
      //save_card: null
    };
  }

  resetStayReservation() {
    this.requestParams = {
      isValid: false,
      is_hourly: this.requestParams['is_hourly'],
      plan_id: this.requestParams['plan_id'],
      reserved_schedules: [],
      reserved_option_items: [],
      reserved_option_foods: [],
      card_type: null,
      token: null,
      dryrun: this.props.currentUser ? false : true,
    };
    this.setState({
      validatedReservation: null,
      isValid: false,
      isRequestViewOpen: false,
      isContactViewOpen: false,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
    });
  }

  subscribeOptionSelectEvent() {
    $(".js-reserve__spinner").each((index, el)=>{
      const $el = $(el);
      const type = $el.data("option-type");
      const option = this.state.room["option_" + type + "s"][$el.data("index")];
      let max = 1;
      let min = 1;
      let disabled = true;
      if (option.countable && option.max_count > 1) {
        max = option.max_count;
        let selected_option = null;
        if (type == "item" && this.requestParams.reserved_option_items.length != 0) {
          this.requestParams.reserved_option_items.map(function(reserved_option_item){
            if (reserved_option_item.option_item_id == option.id) {
              selected_option = reserved_option_item;
            }
          });
        } else if (type == "food" && this.requestParams.reserved_option_foods.length != 0) {
          this.requestParams.reserved_option_foods.map(function(reserved_option_food){
            if (reserved_option_food.option_food_id == option.id) {
              selected_option = reserved_option_food;
            }
          });
        }
        if (max != min && selected_option){
          disabled = false;
        }
      }

      $el.spinner({
        max: max,
        min: min,
        disabled: disabled,
        spin: (event, ui)=>{
          $el.spinner("value", ui.value);
          const listProps = "reserved_option_"+ type +"s";
          const idProps = "option_" + type + "_id";
          let options = this.requestParams[listProps];
          for (let i = 0; i < options.length; i++) {
            if (option.id == options[i][idProps]) {
              options[i].number = ui.value;
              this.requestParams[listProps] = options;
              this.validateReservation();
              break;
            }
          }
          return false;
        }
      });
    });
  }

  subscribeGuestsSelectEvent() {
    $(".js-reserve__spinner_guests").each((index, el) =>{
      const $el = $(el);
      let max = this.state.room.capacity;
      let min = 1;

      $el.spinner({
        max: max,
        min: min,

        spin: (event, ui)=>{
          $el.spinner("value", ui.value);
          this.requestParams.number_of_guests = ui.value;
          this.validateReservation();
          return false;
        }
      });
    });
  }

  planDidSelect(index, e) {
    this.resetReservation();
    const plan = [this.state.room].concat(this.state.room.plans)[index];
    this.requestParams.plan_id = SMPlanHelper.isRoom(plan) ? 0 : plan.id;
    const isHourly = this.getIsHourly(plan);
    this.requestParams.is_hourly = isHourly;

    this.setState({
      validatedReservation: null,
      isRequestViewOpen: false,
      isContactViewOpen: false,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
      numberOfGuests: 1,
      optionItems: {},
      optionFoods: {},
      plan: plan,
      isValid: false,
      isHourly: isHourly,
      rentType: plan.rent_type,
    });

    if (plan.rent_type === SMConst.RentType.Stay) {
      // 宿泊カレンダーを選びなおした際に予約リクエストに進めなくなるバグへの対応
      this.clearCalenderState();
    }
  }

  priceTypeDidSelect(e) {
    const isHourly = e.currentTarget.value;
    this.requestParams.is_hourly = isHourly;
    this.requestParams.reserved_schedules = [];
    this.setState({
      isValid: false,
      isHourly: isHourly,
      rentType : this.state.plan.rent_type,
      priceText: "",
      priceExtraText: "",
      reservedDateText: I18n.t("service.label_000050"),
      validatedReservation: null,
    });
  }

  checkinAtDidSelect(e) {
    const selectedTimeString = e.currentTarget.value;
    const checkinAtHour = parseInt(selectedTimeString.substr(0,2));
    const checkinAtMinute = parseInt(selectedTimeString.substr(3,2));

    const date = new Date(this.requestParams.reserved_schedules[0]["started_at"]);
    const newCheckInDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), checkinAtHour, checkinAtMinute));
    this.requestParams.stay_checkin_at = this.requestParams.reserved_schedules[0]["started_at"] = newCheckInDate.toISOString();

    const checkinAt = Date.parse(newCheckInDate.toISOString());
    const checkoutAt = Date.parse(this.requestParams.stay_checkout_at);
    const duration = (checkoutAt - checkinAt) / (1000 * 60);

    this.requestParams.reserved_schedules[0]["duration"] = duration;

    this.validateReservation();
  }

  optionItemDidSelect(index, e) {
    const $el = $(e.currentTarget);
    const optionItem = this.state.room.option_items[index];
    let selectedIndex = null;
    this.requestParams.reserved_option_items.some((item, index)=>{
      if (item.option_item_id == optionItem.id) {
        selectedIndex = index;
        return true;
      }
    });
    if (selectedIndex != null) {
      this.requestParams.reserved_option_items.splice(selectedIndex, 1);
    } else {
      this.requestParams.reserved_option_items.push({
        option_item_id: optionItem.id,
        number: $("#" + $el.attr("id") + "__number").val(),
      });
    }
    this.validateReservation();
  }

  stayScheduleDidSelect(selectedAt, duration, isCheckinCalendar, checkinEnable) {
    const reservedSchedules = this.requestParams.reserved_schedules ? this.requestParams.reserved_schedules : null;
    if (isCheckinCalendar) {
      if (reservedSchedules && reservedSchedules.length > 0) {
        this.setState({
          validatedReservation : null,
          priceText: "",
          priceExtraText: ""
        });
        this.requestParams.reserved_schedules.map(function(schedule){
          schedule['started_at'] = selectedAt.toISOString();
          schedule['duration'] = duration;
        });
      } else {
        this.requestParams.reserved_schedules.push({
          started_at: selectedAt.toISOString(),
          is_stay_start: 1,
          duration: duration
        });
      }
      this.requestParams.stay_checkin_at = selectedAt.toISOString();
      this.setState({checkinEnable: checkinEnable});
    } else {
      this.requestParams.number_of_guests = 1;
      this.requestParams.number_of_stays = 1;
      this.requestParams.stay_checkout_at = selectedAt.toISOString();
      if (reservedSchedules && reservedSchedules.length > 0) {
        this.requestParams.reserved_schedules[0]["duration"] = duration;
      }
    }
  }

  scheduleDidSelect(startedAt, duration, isSessionStart) {
    const str = startedAt.toISOString();
    let selectedIndex = null;
    let isPrevent = false;
    this.requestParams.reserved_schedules.some((schedule, index)=>{
      if (this.state.plan.has_session_price) {
        for (let i = 0; i < schedule.duration; i += 60) {
          let date = new Date(schedule.started_at);
          date.setUTCHours(date.getUTCHours() + i / 60);
          if (str == date.toISOString()) {
            if (i == 0) {
              selectedIndex = index;
            } else {
              isPrevent = true;
            }
            return true;
          }
        }
      } else {
        if (schedule.started_at == str) {
          selectedIndex = index;
          return true;
        }
      }
    });
    if (isPrevent) {
      return;
    }
    if (selectedIndex != null) {
      this.requestParams.reserved_schedules.splice(selectedIndex, 1);
    } else {
      this.requestParams.reserved_schedules.push({
        started_at: startedAt.toISOString(),
        is_session_start: isSessionStart ? 1 : 0,
        duration: duration,
      });
    }
    if (this.isPerPersonPlan()){
      if (!this.requestParams.number_of_guests) {
        this.requestParams.number_of_guests = 1;
      }
    }
    this.validateReservation();
  }

  saveCalendarState(calendarState) {
    this.setState({
      calendarState: calendarState
    });
  }

  clearCalenderState() {
    this.setState({
      calendarState: ''
    });
  }

  optionFoodDidSelect(index, e) {
    const $el = $(e.currentTarget);
    const optionFood = this.state.room.option_foods[index];
    let selectedIndex = null;
    this.requestParams.reserved_option_foods.some((item, index)=>{
      if (item.option_food_id == optionFood.id) {
        selectedIndex = index;
        return true;
      }
    });
    if (selectedIndex != null) {
      this.requestParams.reserved_option_foods.splice(selectedIndex, 1);
    } else {
      this.requestParams.reserved_option_foods.push({
        option_food_id: optionFood.id,
        number: $("#" + $el.attr("id") + "__number").val(),
      });
    }
    this.validateReservation();
  }

  renderReservationRequest() {
    if (this.state.isValid) {
      return (
        <SMReservationRequestView
          delegate={this}
          room={this.state.room}
          isOpen={this.state.isRequestViewOpen}
          requestParams={this.requestParams}
          currentUser={this.props.currentUser}
          reservation={this.state.validatedReservation}
          inquiry={this.props.inquiry}
          searchSessionId={this.props.searchSessionId}
          />
      );
    } else {
      return null;
    }
  }

  showRequestView(e) {
    e.preventDefault();
    if (!this.props.currentUser) {
      // 現在の選択状態をセッションに退避
      SMStorage.removeSessionItem("SMReservationBaseViewState");
      SMStorage.removeSessionItem("SMReservationBaseViewRequestParams");
      SMStorage.setSessionItem("SMReservationBaseViewState", this.state, 60 * 10);
      SMStorage.setSessionItem("SMReservationBaseViewRequestParams", this.requestParams, 60 * 10);

      SMAppHelper.redirectToLogin();
    }
    if (!this.state.isValid) return;
    // 未ログイン時にエラー回避のためユーザーチェックをする
    if (this.props.currentUser) {
      $(".js-reservation-submit-card").startLoading();
      SMUserResource.getContact(this.props.currentUser.id, (contact, error)=>{
        $(".js-reservation-submit-card").stopLoading();
        if (contact) {
          this.setState({
            isRequestViewOpen: true,
          });
        } else {
          this.setState({
            isContactViewOpen: true,
          });
        }
      });
    }
    SMTrackHelper.criteoBasket(this.props.currentUser? this.props.currentUser.email : "", this.props.room.uid, SMFormatHelper.price(this.state.validatedReservation.billing.total_amount), 1);
  }

  validateReservation() {
    this.setState({display: SMConst.Display.Loading});
    $(".js-reservation-submit-card").stopLoading().startLoading();
    SMRoomResource.validateReservation(this.state.room.id, this.requestParams, (reservation, error, xhr)=>{
      this.setState({display: SMConst.Display.Visible});
      $(".js-reservation-submit-card").stopLoading();
      if(!error) {
        this.setState({
          priceText: reservation.billing.guest_total_amount_except_tax_text,
          priceExtraText: sprintf(I18n.t("service.label_000023"), reservation.billing.guest_total_amount_with_tax_text),
          reservedDateText: reservation.reserved_date_text,
          validatedReservation: reservation,
          isValid: reservation.is_available,
        });
      } else {
        this.setState({errors: xhr.responseJSON.errors});
      }
    });

  }

  // request delegate
  requestViewDidClose() {
    this.setState({
      isRequestViewOpen: false,
    });
  }

  // contact delegate
  contactViewDidClose() {
    this.setState({
      isContactViewOpen: false,
    });
  }

  contactDidCreated() {
    this.setState({
      isContactViewOpen: false,
      isRequestViewOpen: true,
    });
  }

  dayDidSelect(year, month, day, calendars){
    this.setState({
      year: year,
      month: month,
      day: day,
      calendars: calendars,
    });
  }
}
export default SMReservationBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationBaseView.jsx